import styled from 'styled-components'

export const StyledNewsSavedSearchEditButton = styled.div``
